import { DAYS_OF_WEEK } from '../const';

export const MORE_TEXT = 'Посмотреть';
export const MONTHS_LIST = [
  'январь',
  'февраль',
  'март',
  'апрель',
  'май',
  'июнь',
  'июль',
  'август',
  'сентябрь',
  'октябрь',
  'ноябрь',
  'декабрь',
];

export { DAYS_OF_WEEK };



// WEBPACK FOOTER //
// ./src/components/calendar/month/const.ts